module.exports = __webpack_public_path__ + "img/hero-image-2.b3e39c7e.jpg";